import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getThemeDataAction,
  getThemeListDataAction,
  getReportDataAction,
  getReportPartListDataAction,
  getReportPartListByIdDataAction,
} from "../actions/adminPermissionsAction";
import { Modal } from "react-bootstrap";
import { SBAComboBox, SBADropDown } from "../UiComponents/SBADropDown";
import { SBADrawer } from "../UiComponents/SBADrawer";
import { ToastContainer, toast } from "react-toastify";
import { sbaAxios } from "../utils/sbaAxios";
import { SBNotify } from "../utils/sbNotify";
import { SBGrid } from "../UiComponents/SBAAGgrid";
import { component } from "../../config/componentConfig";
import {
  getCustomSettings,
  insertOrUpdateThemedetail,
  UpdateReportPartList,
    insertOrUpdateReport,
    insertUpdateLogo,
} from "../../config/apiConfig";
import { AgGridReact } from "ag-grid-react";
import { Badge, Col, Image } from "react-bootstrap";
import SampleProfile from "../../components/investor/investorDetails/sampleImage/ProfileImage.png"

export const ThemeExcelAddIn = () => {
  const emptyThemeList = {
    ThemeDetail: "",
    ThemeId:"",
    ThemeDetailId: 0,
    TitleFontFamily: "",
    TitleFontSize: "",
    TitleWeight: false,
    TitleBackGroundColor: "",
    TitleFontColor: "",
    GridHeaderFontFamily: "",
    GridHeaderFontSize: "",
    GridHeaderWeight: false,
    GridHeaderBackGroundColor: "",
    GridHeaderFontColor: "",
    GridRowFontFamily: "",
    GridRowFontSize: "",
    GridRowWeight: false,
    GridRowBackGroundColor: "",
    GridRowFontColor: "",
    GridRowAlternateColor: "",
    GridFirstColumnWeight: false,
    GridFirstColumnFontFamily: "",
    GridLastColumnWeight: false,
    GridLastColumnFontFamily: "",
    GridCellNegHighlightColor: "",
    GridCellPosHighlightColor: "",
    ChartPrimaryColor: "",
    ChartSecondaryColor: "",
    ChartAlternateColor: "",
    ChartPlotFontFamily: "",
    ChartPlotFontSize: "",
    ChartPlotWeight: false,
    ChartAxisFontFamily: "",
    ChartAxisFontSize: "",
    ChartAxisWeight: false,
    ChartLegendFontFamily: "",
    ChartLegendFontSize: "",
    ChartLegendWeight: false,
    ChartAxisFontColor: "",
      ChartLegendFontColor: "",
      LogoId: "",
      LogoBigImage:"",
  };
  const emptyReportsList = {
    ReportId: 0,
    ReportTypeId: 0,
    ReportName: "",
    DisplayName: "",
    IsActive: true,
  }
  const emptyReportPartsList = {
    ReportName: "",
    ThemeName: "",
  }
  const emptyReportParts = {
    ReportId: "",
    ReportName:"",
    ReportpartName: "",
    DisplayName: "",
    ReportpartId:"",
    ReportToPartXrefId:0,
  }
  const [render, setRender] = useState(true);
  const [appliedFilter, setAppliedFilter] = useState(null);
  const [themesColDef, setThemesColDef] = useState([]);
  const [showDrawer, setshowDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState(emptyThemeList);
  const [reportsData, setReportsDrawerData] = useState(emptyReportsList);
  const [reportPartsData, setReportPartsDrawerData] = useState(emptyReportPartsList);
  const [reportPartsList, setReportPartListDrawerData] = useState(emptyReportParts);
  const [themeNameDropdown, setThemeNameDropdown] = useState("");
  const [reportNameDropdown, setreportNameDropdown] = useState("");
  const [reportsDrawer, setReportsDrawer] = useState(false);
  const [reportPartDrawer, setReportPartDrawer] = useState(false);
  const [reportPartListDrawer, setReportPartListDrawer] = useState(false);
  const [addOrUpdateBtnName, setAddOrUpdateBtnName] = useState("");
  const [theme, setThemeId] = useState();
  const [drawerTheme, setDrawerThemeId] = useState();
  const [selectedReport, setSelectedReport] = useState();
  const [dataUri, setDataUri] = useState('');
  const [base64Data, setBase64Data] = useState(null);

  useEffect(() => {
    setreportNameDropdown({ReportName:reportPartsList.ReportpartName, ReportId:reportPartsList.ReportpartId})
    setThemeNameDropdown({ThemeDetail:reportPartsList.ThemeDetailName, ThemeDetailId:reportPartsList.ThemeDetailId});
  }, [reportPartsList]);

  useEffect(() => {
    fetchGridData();
  }, []);
  useEffect(()=>{
    const dataURI=drawerData?.LogoBigImage ? `data:image/png;base64,${drawerData?.LogoBigImage}` : null
    setDataUri(dataURI);
    setBase64Data(drawerData.LogoBigImage);
  },[drawerData])
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const maxSizeKB = 200; // Maximum file size in KB

        if (file) {
            // Check the file size
            if (file.size > maxSizeKB * 1024) { // Convert KB to bytes
                // File size exceeds the limit
                SBNotify({ type: "error", Msg: "File size exceeds 200 KB limit." });
                return;
            }

            // File size is within the limit, proceed with reading the file
            const reader = new FileReader();
            reader.onload = function () {
                if (reader.result) {
                    const arrayBuffer = reader.result;
                    const base64String = arrayBufferToBase64(arrayBuffer);
                    setBase64Data(base64String);
                    if (base64String) {
                        setDataUri(`data:image/png;base64,${base64String}`);
                    }
                }
            };
            reader.readAsArrayBuffer(file);
        }
    };


    const arrayBufferToBase64 = (arrayBuffer) => {
        const binary = [];
        const bytes = new Uint8Array(arrayBuffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary.push(String.fromCharCode(bytes[i]));
        }
        return btoa(binary.join(''));
    };

  const getCustomSetting = async () => {
    try {
      const response = await sbaAxios({
        url: `${getCustomSettings}${component.ThemeList}`,
      });
      if (response) {
        const apiColDef = JSON.parse(response.CustomSettingsValue);
        const apiFilters = JSON.parse(response.CustomFilterValue);
        const formattedDef = apiColDef.map((item) => ({
          ...item,
          field: item.colId,
          cellRenderer:
            item.colId === "Edit"
              ? (props) => EditRender(props)
              : item.colId === "Delete"
              ? (props) => DeleteRender(props)
              : item.colId === "TitleWeight" ||
                item.colId === "GridHeaderWeight" ||
                item.colId === "GridRowWeight" ||
                item.colId === "GridFirstColumnWeight" ||
                item.colId === "GridLastColumnWeight" ||
                item.colId === "ChartPlotWeight" ||
                item.colId === "ChartAxisWeight" ||
                item.colId === "ChartLegendWeight"
              ? (props) => CheckBoxRender(props)
              : "",
        }));
        return { columns: formattedDef, filters: apiFilters };
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const fetchGridData = async () => {
    try {
      const customSettings = await getCustomSetting();
      setThemesColDef(customSettings.columns);
      setAppliedFilter(customSettings.filters);
    } catch (error) {
      console.error("Error fetching custom settings:", error);
    }
  };
    const handleDropdown = (e, fieldName) => {
    const themeId = e.value.ThemeId;
    if(fieldName === "themeName"){
        setThemeId({ ThemeName: e.value.ThemeName, ThemeId: e.value.ThemeId });
        setDrawerThemeId({ ThemeName: e.value.ThemeName, ThemeId: e.value.ThemeId })
      dispatch(getThemeListDataAction(e.value.ThemeId));
    }
    if(fieldName === "drawerThemeName"){
      setDrawerThemeId({ThemeName: e.value.ThemeName, ThemeId: e.value.ThemeId});
    }
    if(fieldName === "drawerThemeDetailName"){
      setThemeNameDropdown({ThemeDetail:e.value.ThemeDetail, ThemeDetailId:e.value.ThemeDetailId});
    }
    if(fieldName === "drawerReportpartName"){
      setreportNameDropdown({ReportName:e.value.ReportName, ReportId:e.value.ReportId})
    }
    const updatedState = { ...drawerData, ["ThemeId"]: themeId };
    setDrawerData(updatedState);
  };

  const themeListToggleModal = () => {
    setDrawerData(emptyThemeList);
    setAddOrUpdateBtnName("Save");
    setshowDrawer(true);
  };

  const reportsListToggleModal = () => {
    setReportsDrawerData(emptyReportsList);
    setAddOrUpdateBtnName("Save");
    setReportsDrawer(true);
  };

  const reportPartsListToggleModal = () => {
    setReportPartListDrawerData(emptyReportParts);
    setAddOrUpdateBtnName("Save");
    setReportPartListDrawer(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDrawerData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const reportsListChange = (e) => {
    const { name, value } = e.target;
    setReportsDrawerData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    const value = checked ? true : false;
    const updatedState = { ...drawerData, [name]: value };
    setDrawerData(updatedState);
  };

    const EditRender = (props) => {
     
    const handleEditClick = () => {
      onEditButtonClick(props);
    };
    return (
      <div className="actions-cell">
        <i
          className="fas fa-edit"
          style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
          onClick={handleEditClick}
        ></i>
      </div>
    );
  };

  const DeleteRender = (props) => {
    const handleDeleteClick = () => {};
    return (
      <div className="actions-cell">
        <i
          className="fas fa-trash"
          style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
          onClick={handleDeleteClick}
        ></i>
      </div>
    );
  };
  const CheckBoxRender = (props) => {
    return (
      <div className="actions-cell">
        <input
          type="checkbox"
          className="mb-0"
          checked={props.value === true}
        />
      </div>
    );
  };

  const closeDrawer = () => {
    setshowDrawer(false);
    setReportsDrawer(false);
    setReportPartDrawer(false);
    setReportPartListDrawer(false);
  };

  const onEditButtonClick = (props) => {
    setDrawerData(props.data);
    setAddOrUpdateBtnName("Update");
    setshowDrawer(true);
  };

  const themesGridRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getThemeDataAction());
    dispatch(getThemeListDataAction(null));
    dispatch(getReportDataAction());
    dispatch(getReportPartListDataAction());
  }, [render]);

  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};

  const themeData = Gstate?.AdminPermissions?.ThemeData || [];
  const themeGridData = Gstate?.AdminPermissions?.ThemeListData || [];
  const reportData = Gstate?.AdminPermissions?.ReportData || [];
  const reportPartData = Gstate?.AdminPermissions?.ReportPartListData || [];
  const reportPartListByIdData = Gstate?.AdminPermissions?.ReportPartListByIdData || [];
  useEffect(() => {
    if (themeData[0]?.ThemeId !== null && themeData[0]?.ThemeId !== undefined) {
      setThemeId({
        ThemeName: themeData[0]?.ThemeName,
        ThemeId: themeData[0]?.ThemeId,
      });
        setDrawerThemeId({
            ThemeName: themeData[0]?.ThemeName,
            ThemeId: themeData[0]?.ThemeId,
        });

      dispatch(getThemeListDataAction(themeData[0]?.ThemeId));
    }
  }, [themeData]);
  // const themeGridRowData = Array.isArray(themeGridData)
  //   ? themeGridData.map((row) => {
  //       const rowDataItem = {
  //         ThemeDetailId: row.ThemeDetailId,
  //         ThemeDetail: row.ThemeDetail,
  //         ThemeId: row.ThemeId,
  //         TitleFontFamily: row.TitleFontFamily,
  //         TitleFontSize: row.TitleFontSize,
  //         TitleWeight: row.TitleWeight,
  //         TitleBackGroundColor: row.TitleBackGroundColor,
  //         TitleFontColor: row.TitleFontColor,
  //         GridHeaderFontFamily: row.GridHeaderFontFamily,
  //         GridHeaderFontSize: row.GridHeaderFontSize,
  //         GridHeaderWeight: row.GridHeaderWeight,
  //         GridHeaderBackGroundColor: row.GridHeaderBackGroundColor,
  //         GridHeaderFontColor: row.GridHeaderFontColor,
  //         GridRowFontFamily: row.GridRowFontFamily,
  //         GridRowFontSize: row.GridRowFontSize,
  //         GridRowWeight: row.GridRowWeight,
  //         GridRowBackGroundColor: row.GridRowBackGroundColor,
  //         GridRowFontColor: row.GridRowFontColor,
  //         GridRowAlternateColor: row.GridRowAlternateColor,
  //         GridFirstColumnWeight: row.GridFirstColumnWeight,
  //         GridFirstColumnFontFamily: row.GridFirstColumnFontFamily,
  //         GridLastColumnWeight: row.GridLastColumnWeight,
  //         GridLastColumnFontFamily: row.GridLastColumnFontFamily,
  //         GridCellNegHighlightColor: row.GridCellNegHighlightColor,
  //         GridCellPosHighlightColor: row.GridCellPosHighlightColor,
  //         ChartPrimaryColor: row.ChartPrimaryColor,
  //         ChartSecondaryColor: row.ChartSecondaryColor,
  //         ChartAlternateColor: row.ChartAlternateColor,
  //         ChartPlotFontFamily: row.ChartPlotFontFamily,
  //         ChartPlotFontSize: row.ChartPlotFontSize,
  //         ChartPlotWeight: row.ChartPlotWeight,
  //         ChartAxisFontFamily: row.ChartAxisFontFamily,
  //         ChartAxisFontSize: row.ChartAxisFontSize,
  //         ChartAxisWeight: row.ChartAxisWeight,
  //         ChartLegendFontFamily: row.ChartLegendFontFamily,
  //         ChartLegendFontSize: row.ChartLegendFontSize,
  //         ChartLegendWeight: row.ChartLegendWeight,
  //         ChartAxisFontColor: row.ChartAxisFontColor,
  //           ChartLegendFontColor: row.ChartLegendFontColor,
  //         LogoId:row.LogoId,
  //           LogoBigImage:row.LogoBigImage,
  //       };
  //       return rowDataItem;
  //     })
  //   : [];

  const ReportsEditButtonRenderer = (props) => {
    const handleEditClick = () => {
      setAddOrUpdateBtnName("Update");
      setReportsDrawerData(props.data)
      setReportsDrawer(true);
    };

    return (
      <div className="actions-cell">
        <i
          className="fas fa-edit"
          style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
          onClick={handleEditClick}
        ></i>
      </div>
    );
  };

  const ReportsDeleteButtonRenderer = (props) => {
    const handleDeleteClick = () => {};

    return (
      <div className="actions-cell">
        <i
          className="fas fa-trash"
          style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
          onClick={handleDeleteClick}
        ></i>
      </div>
    );
  };

  const ReportPartEditButtonRenderer = (props) => {
    const handleEditClick = () => {
      setAddOrUpdateBtnName("Update");
      setReportPartsDrawerData(props.data)
      setReportPartDrawer(true);
    };

    return (
      <div className="actions-cell">
        <i
          className="fas fa-edit"
          style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
          onClick={handleEditClick}
        ></i>
      </div>
    );
  };

  const ReportPartDeleteButtonRenderer = (props) => {
    const handleDeleteClick = () => {};

    return (
      <div className="actions-cell">
        <i
          className="fas fa-trash"
          style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
          onClick={handleDeleteClick}
        ></i>
      </div>
    );
  };

  const ReportPartListEditButtonRenderer = (props) => {
    const handleEditClick = () => {
      setAddOrUpdateBtnName("Update");
      setReportPartListDrawerData(props.data)
      setReportPartListDrawer(true);
    };

    return (
      <div className="actions-cell">
        <i
          className="fas fa-edit"
          style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
          onClick={handleEditClick}
        ></i>
      </div>
    );
  };

  const ReportPartListDeleteButtonRenderer = (props) => {
    const handleDeleteClick = () => {};

    return (
      <div className="actions-cell">
        <i
          className="fas fa-trash"
          style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
          onClick={handleDeleteClick}
        ></i>
      </div>
    );
  };

  const reportsColDef = [
    {
      headerName: "Report Name",
      field: "ReportName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Display Name",
      field: "DisplayName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Edit",
      field: "Edit",
      cellRenderer: ReportsEditButtonRenderer,
      maxWidth: 100,
    },
    {
      headerName: "Delete",
      field: "Delete",
      maxWidth: 100,
      cellRenderer: ReportsDeleteButtonRenderer,
    },
  ];

  const reportPartsColDef = [
    {
      headerName: "ReportPart Name",
      field: "ReportName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Display Name",
      field: "DisplayName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Edit",
      field: "Edit",
      cellRenderer: ReportPartEditButtonRenderer,
      maxWidth: 100,
    },
    {
      headerName: "Delete",
      field: "Delete",
      maxWidth: 100,
      cellRenderer: ReportPartDeleteButtonRenderer,
    },
  ];

  const reportPartsListColDef = [
    {
      headerName: "ReportPart Name",
      field: "ReportpartName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Display Name",
      field: "DisplayName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Theme Name",
      field: "ThemeDetailName",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Edit",
      field: "Edit",
      cellRenderer: ReportPartListEditButtonRenderer,
      maxWidth: 100,
    },
    {
      headerName: "Delete",
      field: "Delete",
      maxWidth: 100,
      cellRenderer: ReportPartListDeleteButtonRenderer,
    },
  ];

  const defaultColDef = {
    sortable: false,
    filter: false,
    suppressMovable: true,
    flex: 1,
    resizable:true
  };
  const imageLogoSave = async (bigImage) => {
    let saveSuccess = true;
    const data = {
        LogoId: 1,
        LogoImageFile : bigImage,
    };
    if (saveSuccess) {
        const response = await sbaAxios({
            url: `${insertUpdateLogo}`,
            method: "post",
            data: data,
        });
        // if (response > 0) {
        //     SBNotify({ type: "success", Msg: "Updated Successfully" });
        //     setReportsDrawer(false);
        //     setRender(!render);
        // } else {
        //     SBNotify({ type: "warning", Msg: "Failed" });
        // }
    }
};

  const ReportsRowClicked = (event) => {
   setSelectedReport(event.data)
   dispatch(getReportPartListByIdDataAction(event.data.ReportId))
  }

  const themeListSave = async () => {
    let saveSuccess = true;

    const data = {
      ThemeDetail: drawerData.ThemeDetail,
      ThemeDetailId: drawerData.ThemeDetailId,
      ThemeId: drawerData.ThemeId,
      TitleFontFamily: drawerData.TitleFontFamily,
      TitleFontSize: drawerData.TitleFontSize,
      TitleWeight: drawerData.TitleWeight,
      TitleBackGroundColor: drawerData.TitleBackGroundColor,
      TitleFontColor: drawerData.TitleFontColor,
      GridHeaderFontFamily: drawerData.GridHeaderFontFamily,
      GridHeaderFontSize: drawerData.GridHeaderFontSize,
      GridHeaderWeight: drawerData.GridHeaderWeight,
      GridHeaderBackGroundColor: drawerData.GridHeaderBackGroundColor,
      GridHeaderFontColor: drawerData.GridHeaderFontColor,
      GridRowFontFamily: drawerData.GridRowFontFamily,
      GridRowFontSize: drawerData.GridRowFontSize,
      GridRowWeight: drawerData.GridRowWeight,
      GridRowBackGroundColor: drawerData.GridRowBackGroundColor,
      GridRowFontColor: drawerData.GridRowFontColor,
      GridRowAlternateColor: drawerData.GridRowAlternateColor,
      GridFirstColumnWeight: drawerData.GridFirstColumnWeight,
      GridFirstColumnFontFamily: drawerData.GridFirstColumnFontFamily,
      GridLastColumnWeight: drawerData.GridLastColumnWeight,
      GridLastColumnFontFamily: drawerData.GridLastColumnFontFamily,
      GridCellNegHighlightColor: drawerData.GridCellNegHighlightColor,
      GridCellPosHighlightColor: drawerData.GridCellPosHighlightColor,
      ChartPrimaryColor: drawerData.ChartPrimaryColor,
      ChartSecondaryColor: drawerData.ChartSecondaryColor,
      ChartAlternateColor: drawerData.ChartAlternateColor,
      ChartPlotFontFamily: drawerData.ChartPlotFontFamily,
      ChartPlotFontSize: drawerData.ChartPlotFontSize,
      ChartPlotWeight: drawerData.ChartPlotWeight,
      ChartAxisFontFamily: drawerData.ChartAxisFontFamily,
      ChartAxisFontSize: drawerData.ChartAxisFontSize,
      ChartAxisWeight: drawerData.ChartAxisWeight,
      ChartLegendFontFamily: drawerData.ChartLegendFontFamily,
      ChartLegendFontSize: drawerData.ChartLegendFontSize,
      ChartLegendWeight: drawerData.ChartLegendWeight,
      ChartAxisFontColor: drawerData.ChartAxisFontColor,
        ChartLegendFontColor: drawerData.ChartLegendFontColor,
        LogoId: drawerData.LogoId,
        LogoBigImage : drawerData.LogoBigImage,
      };
     
    const fontFamilyRegex = /^[A-Za-z0-9\s,'"-]+$/;
    const fontWeightRegex = /^(normal|bold|\d{1,3})$/;
    const fontSizeRegex = /^(\d+(\.\d+)?(px|pt|em|%|in|cm|mm|pc|ex)?|larger|smaller)$/;
    const colorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

    if (drawerData.ThemeId === "") {
      SBNotify({ type: "error", Msg: "Please Select Theme Name" });
      saveSuccess = false;
    }
    if (drawerData.ThemeDetail === null || drawerData.ThemeDetail.trim() === "" ) {
      SBNotify({ type: "error", Msg: "Please Enter ThemeDetail" });
      saveSuccess = false;
    }
    if(drawerData.TitleFontFamily === "" && !fontFamilyRegex.test(drawerData.TitleFontFamily)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Title Font Family" });
      saveSuccess = false;
    }
    if(drawerData.GridHeaderFontFamily === "" && !fontFamilyRegex.test(drawerData.GridHeaderFontFamily)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid Header Font Family" });
      saveSuccess = false;
    }
    if(drawerData.GridRowFontFamily === "" && !fontFamilyRegex.test(drawerData.GridRowFontFamily)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid Row Font Family" });
      saveSuccess = false;
    }
    if(drawerData.GridFirstColumnFontFamily === "" && !fontFamilyRegex.test(drawerData.GridFirstColumnFontFamily)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid First Column Font Family" });
      saveSuccess = false;
    }
    if(drawerData.GridLastColumnFontFamily === "" && !fontFamilyRegex.test(drawerData.GridLastColumnFontFamily)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid Last Column Font Family" });
      saveSuccess = false;
    }
    if(drawerData.ChartPlotFontFamily === "" && !fontFamilyRegex.test(drawerData.ChartPlotFontFamily)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Chart Plot Font Family" });
      saveSuccess = false;
    }
    if(drawerData.ChartAxisFontFamily === "" && !fontFamilyRegex.test(drawerData.ChartAxisFontFamily)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Chart Axis Font Family" });
      saveSuccess = false;
    }
    if(drawerData.ChartLegendFontFamily === "" && !fontFamilyRegex.test(drawerData.ChartLegendFontFamily)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Chart Legend Font Family" });
      saveSuccess = false;
    }
    // if(drawerData.TitleWeight === "" && !fontWeightRegex.test(drawerData.TitleWeight)){
    //   SBNotify({ type: "error", Msg: "Please Enter Valid Title Weight" });
    //   saveSuccess = false;
    // }
    // if(drawerData.GridHeaderWeight === "" && !fontWeightRegex.test(drawerData.GridHeaderWeight)){
    //   SBNotify({ type: "error", Msg: "Please Enter Valid Grid Header Weight" });
    //   saveSuccess = false;
    // }
    // if(drawerData.GridRowWeight === "" && !fontWeightRegex.test(drawerData.GridRowWeight)){
    //   SBNotify({ type: "error", Msg: "Please Enter Valid Grid Row Weight" });
    //   saveSuccess = false;
    // }
    // if(drawerData.GridFirstColumnWeight === "" && !fontWeightRegex.test(drawerData.GridFirstColumnWeight)){
    //   SBNotify({ type: "error", Msg: "Please Enter Valid Grid First Column Weight" });
    //   saveSuccess = false;
    // }
    // if(drawerData.GridLastColumnWeight === "" && !fontWeightRegex.test(drawerData.GridLastColumnWeight)){
    //   SBNotify({ type: "error", Msg: "Please Enter Valid Grid Last Column Weight" });
    //   saveSuccess = false;
    // }
    // if(drawerData.ChartPlotWeight === "" && !fontWeightRegex.test(drawerData.ChartPlotWeight)){
    //   SBNotify({ type: "error", Msg: "Please Enter Valid Chart Plot Weight" });
    //   saveSuccess = false;
    // }
    // if(drawerData.ChartAxisWeight === "" && !fontWeightRegex.test(drawerData.ChartAxisWeight)){
    //   SBNotify({ type: "error", Msg: "Please Enter Valid Chart Axis Weight" });
    //   saveSuccess = false;
    // }
    // if(drawerData.ChartLegendWeight === "" && !fontWeightRegex.test(drawerData.ChartLegendWeight)){
    //   SBNotify({ type: "error", Msg: "Please Enter Valid Chart Legend Weight" });
    //   saveSuccess = false;
    // }

    if(drawerData.TitleFontSize === "" && !fontSizeRegex.test(drawerData.TitleFontSize)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Title Font Size" });
      saveSuccess = false;
    }
    if(drawerData.GridHeaderFontSize === "" && !fontSizeRegex.test(drawerData.GridHeaderFontSize)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid Header Font Size" });
      saveSuccess = false;
    }
    if(drawerData.GridRowFontSize === "" && !fontSizeRegex.test(drawerData.GridRowFontSize)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid Row Font Size" });
      saveSuccess = false;
    }
    if(drawerData.ChartPlotFontSize === "" && !fontSizeRegex.test(drawerData.ChartPlotFontSize)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Chart Plot Font Size" });
      saveSuccess = false;
    }
    if(drawerData.ChartAxisFontSize === "" && !fontSizeRegex.test(drawerData.ChartAxisFontSize)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Chart Axis Font Size" });
      saveSuccess = false;
    }
    if(drawerData.ChartLegendFontSize === "" && !fontSizeRegex.test(drawerData.ChartLegendFontSize)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Chart Legend Font Size" });
      saveSuccess = false;
    }
    if(drawerData.TitleFontColor === "" && !colorRegex.test(drawerData.TitleFontColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Title Font Color" });
      saveSuccess = false;
    }
    if(drawerData.TitleBackGroundColor === "" && !colorRegex.test(drawerData.TitleBackGroundColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Title BackGround Color" });
      saveSuccess = false;
    }
    if(drawerData.GridHeaderBackGroundColor === "" && !colorRegex.test(drawerData.GridHeaderBackGroundColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid Header BackGround Color" });
      saveSuccess = false;
    }
    if(drawerData.GridHeaderFontColor === "" && !colorRegex.test(drawerData.GridHeaderFontColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid Header Font Color" });
      saveSuccess = false;
    }
    if(drawerData.GridRowBackGroundColor === "" && !colorRegex.test(drawerData.GridRowBackGroundColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid Row BackGround Color" });
      saveSuccess = false;
    }
    if(drawerData.GridRowFontColor === "" && !colorRegex.test(drawerData.GridRowFontColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid Row Font Color" });
      saveSuccess = false;
    }
    if(drawerData.GridRowAlternateColor === "" && !colorRegex.test(drawerData.GridRowAlternateColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid Row Alternate Color" });
      saveSuccess = false;
    }
    if(drawerData.GridCellNegHighlightColor === "" && !colorRegex.test(drawerData.GridCellNegHighlightColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid Cell Neg Highlight Color" });
      saveSuccess = false;
    }
    if(drawerData.GridCellPosHighlightColor === "" && !colorRegex.test(drawerData.GridCellPosHighlightColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Grid Cell Pos Highlight Color" });
      saveSuccess = false;
    }
    if(drawerData.ChartPrimaryColor === "" && !colorRegex.test(drawerData.ChartPrimaryColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Chart Primary Color" });
      saveSuccess = false;
    }
    if(drawerData.ChartSecondaryColor === "" && !colorRegex.test(drawerData.ChartSecondaryColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Chart Secondary Color" });
      saveSuccess = false;
    }
    if(drawerData.ChartAlternateColor === "" && !colorRegex.test(drawerData.ChartAlternateColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Chart Alternate Color" });
      saveSuccess = false;
    }
    if(drawerData.ChartAxisFontColor === "" && !colorRegex.test(drawerData.ChartAxisFontColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Chart Axis Font Color" });
      saveSuccess = false;
    }
    if(drawerData.ChartLegendFontColor === "" && !colorRegex.test(drawerData.ChartLegendFontColor)){
      SBNotify({ type: "error", Msg: "Please Enter Valid Chart Legend Font Color" });
      saveSuccess = false;
      }   

     
    if (saveSuccess) {
      const response = await sbaAxios({
        url: `${insertOrUpdateThemedetail}`,
        method: "post",
        data: data,
      });
    imageLogoSave(base64Data);
      if (response > 0) {
        SBNotify({ type: "success", Msg: "Updated Successfully" });
        setshowDrawer(false);        
        setRender(!render);
      } else {
        SBNotify({ type: "warning", Msg: "Failed" });
      }
    }
  };

  const reportPartsListSave = async () => {
    let saveSuccess = true;

    const data = {
      ReportId: selectedReport.ReportId,
      ReportPartId: reportNameDropdown.ReportId,
      ThemeDetailId: themeNameDropdown.ThemeDetailId,
      ReportToPartXrefId: reportPartsList.ReportToPartXrefId,
    };

    if (reportNameDropdown.ReportId === "") {
      SBNotify({ type: "error", Msg: "Please Enter Report Name" });
      saveSuccess = false;
    }
    if (themeNameDropdown.ThemeDetailId === undefined) {
      SBNotify({ type: "error", Msg: "Please Enter ThemeDetail" });
      saveSuccess = false;
    }

    if (saveSuccess) {
      const response = await sbaAxios({
        url: `${UpdateReportPartList}`,
        method: "post",
        data: data,
      });
      if (response > 0) {
        SBNotify({ type: "success", Msg: "Updated Successfully" });
        setReportPartListDrawer(false);        
        dispatch(getReportPartListByIdDataAction(selectedReport.ReportId))
      }else if (response === -1) {
        SBNotify({ type: "warning", Msg: "Report Name Already Exists" });
      }
      else {
        SBNotify({ type: "warning", Msg: "Report Name Already Exists" });
      }
    }
  };

  const reportsListSave = async () => {
    let saveSuccess = true;

    const data = {
      reportId: reportsData.ReportId,
      reportTypeId: reportsData.ReportTypeId,
      reportName: reportsData.ReportName,
      displayName: reportsData.DisplayName,
      isActive: reportsData.IsActive,
    };

    if (
      reportsData.ReportName === "" ) {
      SBNotify({ type: "error", Msg: "Please Enter ReportName" });
      saveSuccess = false;
    }
    if (
      reportsData.DisplayName === "" ) {
      SBNotify({ type: "error", Msg: "Please Enter DisplayName" });
      saveSuccess = false;
    }

    if (saveSuccess) {
      const response = await sbaAxios({
        url: `${insertOrUpdateReport}`,
        method: "post",
        data: data,
      });
      if (response > 0) {
        SBNotify({ type: "success", Msg: "Updated Successfully" });
        setReportsDrawer(false);        
        setRender(!render);
      } else {
        SBNotify({ type: "warning", Msg: "Failed" });
      }
    }
  };

  return (
    <>
      <br></br>
      <div className="row flex-wrap">
        <div className="col-lg-4 mb-4">
          <label className="mb-1 ms-2 fw-semibold fs-12">
            Select Theme Name
          </label>
          <div>
            <SBADropDown
              data={themeData}
              textField={"ThemeName"}
              valueField={"ThemeId"}
              onChange={(e) => handleDropdown(e, "themeName")}
              value={theme}
            />
          </div>
        </div>
        <div className="header-container m-2 fs-12 col-lg-12">
          <b> Available Theme List </b>
          {/*<button className="p-sm-btn mx-1" onClick={themeListToggleModal}>*/}
          {/*  <i className="fa-solid fa-plus" /> Add*/}
          {/*</button>*/}
        </div>
        <div
          className="ag-theme-alpine m-1 mb-4 col-lg-12"
          style={{ height: "500px" }}
        >
          <SBGrid
            ref={themesGridRef}
            column={themesColDef}
            row={themeGridData}
            filters={appliedFilter}
            componentID={component.ThemeList}
            gridStyle={{ width: "100%" }}
          ></SBGrid>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="header-container m-2 fs-12">
              <b> Available Reports List </b>
              <button className="p-sm-btn mx-1" onClick={reportsListToggleModal}>
                <i className="fa-solid fa-plus" /> Add
              </button>
            </div>
            <div
              className="ag-theme-alpine m-1 mb-4 col-lg-6"
              style={{ height: "500px", width: "100%" }}
            >
              <AgGridReact
                columnDefs={reportsColDef}
                rowData={reportData}
                defaultColDef={defaultColDef}
                onRowClicked={ReportsRowClicked}
                rowSelection={"single"}
              />
            </div>
          </div>
          {selectedReport && (
            <div className="col-lg-6">
              <div className="header-container m-2 fs-12">
                <b> Available Report Parts for {selectedReport?.ReportName} </b>
                <button className="p-sm-btn mx-1" onClick={reportPartsListToggleModal}>
                  <i className="fa-solid fa-plus" /> Add
                </button>
              </div>
              <div
                className="ag-theme-alpine m-1 mb-4 col-lg-6"
                style={{ height: "500px", width: "100%" }}
              >
                <AgGridReact
                  columnDefs={reportPartsListColDef}
                  rowData={reportPartListByIdData}
                  defaultColDef={defaultColDef}
                  onRowClicked={ReportsRowClicked}
                  rowSelection={"single"}
                />
              </div>
            </div>
          )}
        </div>
        <div className="header-container m-2 fs-12 col-lg-6">
          <b> Available Report Parts List </b>
        </div>
        <div
          className="ag-theme-alpine m-1 mb-4 col-lg-6"
          style={{ height: "500px" }}
        >
          <AgGridReact
            columnDefs={reportPartsColDef}
            rowData={reportPartData}
            defaultColDef={defaultColDef}
          />
        </div>
      </div>
      <SBADrawer
        open={showDrawer}
        setOpen={setshowDrawer}
        close={false}
        title={"Add / Update Theme List"}
        size={"100rem"}
      >
        <div>
                  <div className="col-lg-4 row m-0 mb-4">
                      <label className="mb-1 ms-2 fw-semibold fs-12">
                          Select Theme Name<span class="mandatory">*</span>
                      </label>
                      <div className="col-lg-6">
                          <SBADropDown
                              data={themeData}
                              textField={"ThemeName"}
                              valueField={"ThemeId"}
                              popupSettings={{ className: "modalDD" }}
                              onChange={(e) => handleDropdown(e, "drawerThemeName")}
                              value={drawerTheme}
                          />
                      </div>
                      <div className="col-lg-2 mb-2">
                          <div className="row ">
                              <div className="col">
                                  <Image src={dataUri ? dataUri : SampleProfile}
                                      rounded
                                      style={{ width: "300px" , height:"100px"}} />
                              </div>
                              
                          </div>
                          <div className="mb-4 fileValue" style={{ paddingLeft: "320px", marginTop: "-20px" }}>
                              <input
                                  id="fileInput"
                                  type="file"
                                  accept=".png, .jpg, .jpeg, image/*"
                                  onChange={handleFileChange}
                              />
                          </div>

                      </div>
                  </div>

          <div className="col-lg-12 row m-0 mb-4 gap-2">
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Theme Details</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="ThemeDetail"
                  Value={drawerData?.ThemeDetail || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Title Font Color</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="TitleFontColor"
                  Value={drawerData?.TitleFontColor || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Title Font Family</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="TitleFontFamily"
                  Value={drawerData?.TitleFontFamily || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium">Title BackGround Color</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="TitleBackGroundColor"
                  Value={drawerData?.TitleBackGroundColor || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2 ms-3">
              <div className="mb-4">
                <span className="fw-medium mb-4">Title Weight</span>
                <span class="mandatory">*</span>
                <div className="mb-4">
                  <input
                    type="checkbox"
                    className="mb-0"
                    name="TitleWeight"
                    checked={drawerData?.TitleWeight === true}
                    onChange={handleCheckbox}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12 row m-0 mb-4 gap-2">
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">Title Font Size</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="TitleFontSize"
                  Value={drawerData?.TitleFontSize || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">GridHeaderFontColor</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="GridHeaderFontColor"
                  Value={drawerData?.GridHeaderFontColor || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12 row m-0 mb-4 gap-2">
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">GridHeaderFontFamily</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="GridHeaderFontFamily"
                  Value={drawerData?.GridHeaderFontFamily || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">GridHeaderFontSize</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="GridHeaderFontSize"
                  Value={drawerData?.GridHeaderFontSize || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2 ms-3">
              <div className="mb-4">
                <span className="fw-medium mb-4">GridHeaderWeight</span>
                <span class="mandatory">*</span>
                <div className="mb-4">
                  <input
                    type="checkbox"
                    className="mb-0"
                    name="GridHeaderWeight"
                    checked={drawerData?.GridHeaderWeight === true}
                    onChange={handleCheckbox}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium">GridHeaderBackGroundColor</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="GridHeaderBackGroundColor"
                  Value={drawerData?.GridHeaderBackGroundColor || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">GridRowFontColor</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="GridRowFontColor"
                  Value={drawerData?.GridRowFontColor || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12 row m-0 mb-4 gap-2">
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">GridRowFontFamily</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="GridRowFontFamily"
                  Value={drawerData?.GridRowFontFamily || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">GridRowFontSize</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="GridRowFontSize"
                  Value={drawerData?.GridRowFontSize || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2 ms-3">
              <div className="mb-4">
                <span className="fw-medium mb-4">GridRowWeight</span>
                <span class="mandatory">*</span>
                <div className="mb-4">
                  <input
                    type="checkbox"
                    className="mb-0"
                    name="GridRowWeight"
                    checked={drawerData?.GridRowWeight === true}
                    onChange={handleCheckbox}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium">GridRowBackGroundColor</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="GridRowBackGroundColor"
                  Value={drawerData?.GridRowBackGroundColor || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">GridRowAlternateColor</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="GridRowAlternateColor"
                  Value={drawerData?.GridRowAlternateColor || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12 row m-0 mb-4 gap-2">
            <div className="col-md-2 ms-3">
              <div className="mb-4">
                <span className="fw-medium mb-4">GridFirstColumnWeight</span>
                <span class="mandatory">*</span>
                <div className="mb-4">
                  <input
                    type="checkbox"
                    className="mb-0"
                    name="GridFirstColumnWeight"
                    checked={drawerData?.GridFirstColumnWeight === true}
                    onChange={handleCheckbox}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">GridFirstColumnFontFamily</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="GridFirstColumnFontFamily"
                  Value={drawerData?.GridFirstColumnFontFamily || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">GridLastColumnFontFamily</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="GridLastColumnFontFamily"
                  Value={drawerData?.GridLastColumnFontFamily || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-3 ms-3">
              <div className="mb-4">
                <span className="fw-medium mb-4">GridLastColumnWeight</span>
                <span class="mandatory">*</span>
                <div className="mb-4">
                  <input
                    type="checkbox"
                    className="mb-0"
                    name="GridLastColumnWeight"
                    checked={drawerData?.GridLastColumnWeight === true}
                    onChange={handleCheckbox}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">ChartPlotFontFamily</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="ChartPlotFontFamily"
                  Value={drawerData?.ChartPlotFontFamily || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12 row m-0 mb-4 gap-2">
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">ChartAxisFontFamily</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="ChartAxisFontFamily"
                  Value={drawerData?.ChartAxisFontFamily || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">ChartAxisFontSize</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="ChartAxisFontSize"
                  Value={drawerData?.ChartAxisFontSize || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2 ms-3">
              <div className="mb-4">
                <span className="fw-medium mb-4">ChartAxisWeight</span>
                <span class="mandatory">*</span>
                <div className="mb-4">
                  <input
                    type="checkbox"
                    className="mb-0"
                    name="ChartAxisWeight"
                    checked={drawerData?.ChartAxisWeight === true}
                    onChange={handleCheckbox}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium">ChartAxisFontColor</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="ChartAxisFontColor"
                  Value={drawerData?.ChartAxisFontColor || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">ChartPlotFontSize</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="ChartPlotFontSize"
                  Value={drawerData?.ChartPlotFontSize || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-12 row m-0 mb-4 gap-2">
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">ChartLegendFontFamily</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="ChartLegendFontFamily"
                  Value={drawerData?.ChartLegendFontFamily || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-4">
                <span className="fw-medium">ChartLegendFontSize</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="ChartLegendFontSize"
                  Value={drawerData?.ChartLegendFontSize || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2 ms-3">
              <div className="mb-4">
                <span className="fw-medium mb-4">ChartLegendWeight</span>
                <span class="mandatory">*</span>
                <div className="mb-4">
                  <input
                    type="checkbox"
                    className="mb-0"
                    name="ChartLegendWeight"
                    checked={drawerData?.ChartLegendWeight === true}
                    onChange={handleCheckbox}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="mb-4">
                <span className="fw-medium">ChartLegendFontColor</span>
                <span class="mandatory">*</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="ChartLegendFontColor"
                  Value={drawerData?.ChartLegendFontColor || ""}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-2 ms-3">
              <div className="mb-4">
                <span className="fw-medium mb-4">ChartPlotWeight</span>
                <span class="mandatory">*</span>
                <div className="mb-4">
                  <input
                    type="checkbox"
                    className="mb-0"
                    name="ChartPlotWeight"
                    checked={drawerData?.ChartPlotWeight === true}
                    onChange={handleCheckbox}
                  />
                </div>
              </div>
            </div>
                  </div>
                  <div className="col-lg-12 row m-0 mb-4 gap-2">
                      <div className="col-md-2">
                          <div className="mb-4">
                              <span className="fw-medium">GridCellNegHighlightColor</span>
                              <span class="mandatory">*</span>
                              <input
                                  className="form-control w-75"
                                  type="text"
                                  name="GridCellNegHighlightColor"
                                  Value={drawerData?.GridCellNegHighlightColor || ""}
                                  onChange={handleChange}
                              />
                          </div>
                      </div>
                      <div className="col-md-2">
                          <div className="mb-4">
                              <span className="fw-medium">GridCellPosHighlightColor</span>
                              <span class="mandatory">*</span>
                              <input
                                  className="form-control w-75"
                                  type="text"
                                  name="GridCellPosHighlightColor"
                                  Value={drawerData?.GridCellPosHighlightColor || ""}
                                  onChange={handleChange}
                              />
                          </div>
                      </div>
                      <div className="col-md-2 ms-3">
                          <div className="mb-4">
                              <span className="fw-medium">ChartPrimaryColor</span>
                              <span class="mandatory">*</span>
                              <input
                                  className="form-control w-75"
                                  type="text"
                                  name="ChartPrimaryColor"
                                  Value={drawerData?.ChartPrimaryColor || ""}
                                  onChange={handleChange}
                              />
                          </div>
                      </div>
                      <div className="col-md-3">
                          <div className="mb-4">
                              <span className="fw-medium">ChartSecondaryColor</span>
                              <span class="mandatory">*</span>
                              <input
                                  className="form-control w-75"
                                  type="text"
                                  name="ChartSecondaryColor"
                                  Value={drawerData?.ChartSecondaryColor || ""}
                                  onChange={handleChange}
                              />
                          </div>
                      </div>
                      <div className="col-md-2 ms-3">
                          <div className="mb-4">
                              <span className="fw-medium">ChartAlternateColor</span>
                              <span class="mandatory">*</span>
                              <input
                                  className="form-control w-75"
                                  type="text"
                                  name="ChartAlternateColor"
                                  Value={drawerData?.ChartAlternateColor || ""}
                                  onChange={handleChange}
                              />
                          </div>
                      </div>
                   
                  </div>

          <div className="mt-4">
            <button className="s-sm-btn mx-1" onClick={closeDrawer}>
              Cancel
            </button>
            <button className="p-sm-btn mx-1" onClick={themeListSave}>
              {addOrUpdateBtnName}
            </button>
          </div>
        </div>
      </SBADrawer>
      <SBADrawer
        open={reportsDrawer}
        setOpen={setReportsDrawer}
        close={false}
        title={"Add / Update Reports List"}
        size={"50rem"}
      >
        <div>
          <div className="col-lg-12 row m-0 mb-4 gap-2">
            <div className="col-md-6">
              <div className="mb-4">
                <span className="fw-medium">Report Name</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="ReportName"
                  Value={reportsData.ReportName}
                  onChange={reportsListChange}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-4">
                <span className="fw-medium">Display Name</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="DisplayName"
                  Value={reportsData.DisplayName}
                  onChange={reportsListChange}
                />
              </div>
            </div>
          </div>
          <div className="mt-4">
            <button className="s-sm-btn mx-1" onClick={closeDrawer}>
              Cancel
            </button>
            <button className="p-sm-btn mx-1" onClick={reportsListSave}>{addOrUpdateBtnName}</button>
          </div>
        </div>
      </SBADrawer>
      <SBADrawer
        open={reportPartDrawer}
        setOpen={setReportPartDrawer}
        close={false}
        title={"Add / Update ReportPart List"}
        size={"50rem"}
      >
        <div>
          <div className="col-lg-12 row m-0 mb-4 gap-2">
            <div className="col-md-6">
              <div className="mb-4">
                <span className="fw-medium">ReportPart Name</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="ReportName"
                  Value={reportPartsData.ReportName}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-4">
                <span className="fw-medium">Display Name</span>
                <input
                  className="form-control w-75"
                  type="text"
                  name="DisplayName"
                  Value={reportPartsData.DisplayName}
                />
              </div>
            </div>
          </div>

          <div className="mt-4">
            <button className="s-sm-btn mx-1" onClick={closeDrawer}>
              Cancel
            </button>
            <button className="p-sm-btn mx-1">{addOrUpdateBtnName}</button>
          </div>
        </div>
      </SBADrawer>
      <SBADrawer
        open={reportPartListDrawer}
        setOpen={setReportPartListDrawer}
        close={false}
        title={`Add / Update Report Parts for ${selectedReport?.ReportName}`}
        size={"50rem"}
      >
        <div>
          <div className="col-lg-12 row m-0 mb-4 gap-2">
            <div className="col-md-6">
              <div className="mb-4">
                <span className="fw-medium">ReportPart Name</span>                
                 <SBADropDown
                  data={reportPartData}
                  textField={"ReportName"}
                  valueField={"ReportId"}
                  popupSettings={{ className: "modalDD" }}
                  onChange={(e) => handleDropdown(e, "drawerReportpartName")}
                  value={reportNameDropdown}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-4">
                <span className="fw-medium">Theme Name</span>
                <SBADropDown
                  data={themeGridData}
                  textField={"ThemeDetail"}
                  valueField={"ThemeDetailId"}
                  popupSettings={{ className: "modalDD" }}
                  onChange={(e) => handleDropdown(e, "drawerThemeDetailName")}
                  value={themeNameDropdown}
                />
              </div>
            </div>
          </div>

          <div className="mt-4">
            <button className="s-sm-btn mx-1" onClick={closeDrawer}>
              Cancel
            </button>
            <button className="p-sm-btn mx-1" onClick={reportPartsListSave}>{addOrUpdateBtnName}</button>
          </div>
        </div>
      </SBADrawer>
    </>
  );
};
